export default "__VITE_ASSET__Cy12MXrV__"